import { Component } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { StatusBar } from '@capacitor/status-bar';
import { PrivacyScreen } from '@capacitor-community/privacy-screen';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor() {
    if ((Capacitor as any).isNative) {
        StatusBar.setOverlaysWebView({ overlay: false })
      }

      this.enable()
  }

  private enable = async () => {
    await PrivacyScreen.enable();
  };

  private disable = async () => {
    await PrivacyScreen.disable();
  };
}
